import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from '@angular/core';

@Component({
  selector: 'app-image-input',
  template: `
    <input
      #input
      type="file"
      accept="image/*"
      (change)="changed($event)"
      style="display: none"
    />
  `,
})
export class ImageInputComponent implements OnInit {
  @ViewChild('input', { static: true }) input: ElementRef<HTMLInputElement>;

  private _file;

  @Output() imageChange = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {}

  changed(event: any): void {
    this._file = this.input.nativeElement.files[0];
    this.imageChange.emit(this._file);
  }

  startUpload(): void {
    this.input.nativeElement.click();
  }

  reset(): void {
    this.input.nativeElement.value = '';
    this._file = null;
    this.imageChange.emit(this._file);
  }

  get file(): any {
    return this._file;
  }
}
